import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CmsStudioComponent } from './cmsstudio/cmsstudio.component';
import { CmsViewComponent } from './cmsview/cmsview.component'
import { CmspreviewComponent } from './cmsview/cmspreview.component';
import { CmsComponent } from './cms.component';
import { CmsAccessComponent } from './cmsaccess/cmsaccess.component';
import { AdminAuthGuard } from '../admin/admin.authguard';
const routes: Routes = [
    {
        path: 'studio',
        component: CmsStudioComponent,
        canActivate: [AdminAuthGuard],
        data: {
            breadcrumb: '',
            menuId: 11
        },
    },
    {
        path: 'view',
        component: CmsViewComponent,
        children: [
            {
                path: ':selector/:selectorValue',
                component: CmspreviewComponent,
            }
        ],
    },
    {
        path: 'cms',
        component: CmsComponent,
        canActivate: [AdminAuthGuard],
        data: {
            breadcrumb: ''
            
        },
    },
    {
        path: 'cmsaccess',
        component: CmsAccessComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class CmsRoutingModule { }
